import { render, staticRenderFns } from "./ScreenSidebar.vue?vue&type=template&id=bd7c7a70&scoped=true"
import script from "./ScreenSidebar.vue?vue&type=script&lang=js"
export * from "./ScreenSidebar.vue?vue&type=script&lang=js"
import style0 from "./ScreenSidebar.vue?vue&type=style&index=0&id=bd7c7a70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7c7a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd7c7a70')) {
      api.createRecord('bd7c7a70', component.options)
    } else {
      api.reload('bd7c7a70', component.options)
    }
    module.hot.accept("./ScreenSidebar.vue?vue&type=template&id=bd7c7a70&scoped=true", function () {
      api.rerender('bd7c7a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/ScreenSidebar.vue"
export default component.exports